import { Row, Col, Alert, Card } from 'antd';
import { useLanguage } from '../utils/LanguageContext';
import translations from '../components/ComponentsTranslations.lang.json';
import { EmploymentSetupStatus } from '../shared/constants/employmentConstants';
import { OneTimeActionButton } from './common/CommonComponents';
import { useAuth } from '../utils/AuthContext';
import PayrollElectionForm from './PayrollElectionForm';

const EmployerOnboardedPayrollStatus = ({ employment }) => {
  const { lang } = useLanguage(translations);
  const { api } = useAuth();

  const { employmentId, employerName, status } = employment;

  return (
    <>
      <Row gutter={16}>
        <Col span={24}>
          {status === EmploymentSetupStatus.REQUESTED_BY_EMPLOYER && (
            <Card title={employerName}>
              <Alert
                description={
                  <>
                    {lang('employerRequestsToContribute')}{' '}
                    <OneTimeActionButton
                      onClick={async () => await api.acceptEmployment(employmentId)}
                      confirmation={lang('acceptEmploymentSuccessful')}
                    >
                      {lang('acceptEmployment')}
                    </OneTimeActionButton>
                  </>
                }
              />
            </Card>
          )}
          {status === EmploymentSetupStatus.INITIATED_BY_EMPLOYEE && (
            <Card title={employerName}>
              <PayrollElectionForm employment={employment} submitLabel={lang('finish')} />
            </Card>
          )}
          {status === EmploymentSetupStatus.PENDING_ADMIN_PROCESSING && (
            <Alert description={lang('payrollEmployerAccountStatus')} type="warning" />
          )}
          {status === EmploymentSetupStatus.ACTIVE_EMPLOYMENT && (
            <Alert description={lang('activeEmployerAccountStatus')} type="success" />
          )}
        </Col>
      </Row>
    </>
  );
};

export default EmployerOnboardedPayrollStatus;
